<template>
  <component
    :is="tag"
    class="btn base-button"
    :class="{
      'btn-default': variant === 'default',
      'btn-primary': variant === 'primary',
      'btn-secondary': variant === 'secondary',
      'btn-inline': inline,
      'btn-small': size === 'small',
    }"
    :disabled="disabled"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="btn-inner">
      <slot />
      <ArrowRight v-if="showArrow" class="btn-icon" />
    </div>
  </component>
</template>

<script>
import ArrowRight from '@/assets/arrow-right.svg';

export default {
  components: { ArrowRight },
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    variant: {
      type: String,
      default: 'default',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'regular',
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  border: 1px solid var(--dark-blue);
  border-radius: 10px;
  box-sizing: border-box;
  color: var(--orange);
  display: block;
  padding: 17px 27px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 17px;
  text-decoration: none;
  transition: background-color 0.3s ease, opacity 0.3s ease;
  width: 100%;

  &[disabled] {
    opacity: 0.6;
  }
}

.btn-inner {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.btn-inline {
  display: inline-block;
  width: auto;
}

.btn-default {
  color: var(--dark-blue);

  &:hover {
    background: var(--dark-blue-hover);
    color: var(--orange);
  }
}

.btn-primary {
  background: var(--dark-blue);
  color: var(--yellow);

  &:hover {
    background: var(--dark-blue-hover);
  }
}

.btn-secondary {
  background: var(--light-blue);
  border-color: var(--light-blue);
  color: var(--yellow);

  &:hover {
    background: var(--light-dim-blue);
  }
}

.btn-small {
  border-radius: 100px;
  font-size: 12px;
  padding: 8px 12px;
}

.btn-icon {
  margin-left: 24px;
}
</style>
